module.exports = __webpack_public_path__ + "static/media/404_desktop.11826400b877313e11144b615a2489ea.svg";